import $store from '@/store';
import api from '@/modules/searcher/api';
import isArray from 'lodash/isArray';
import isObject from 'lodash/isObject';
import { $t, translateCandidates } from '@/utils';
import LRU from 'lru-cache';

const cache = new LRU({ maxAge: 1000 * 60 });

export function entityIcon(type) {
  const icon = $store.getters.getEntityConfig(type).icon;
  if (!icon) {
    return 'bug_report';
  }
  return icon;
}

export function entityTypeTranslation(type) {
  return translateCandidates(
    [
      `message.entity.type.${type}`,
      `message.searcher.filters.values.type.${type}`,
      `message.wizard.${type}`,
    ],
    `message.entity.type.${type}`,
  );
}

export async function resolveEntityType(entity, id) {
  const { type } = await api.fetch(entity, id);
  return type;
}

export async function resolveEntityTypeFromFieldConfigAndFieldValue(fieldConfig, fieldValue) {
  if (isObject(fieldValue) && fieldValue.type) {
    return isArray(fieldValue.type) ? fieldValue.type[0] : fieldValue.type;
  }
  if (fieldConfig.params.type
    && !isArray(fieldConfig.params.type)
  ) {
    return fieldConfig.params.type;
  }

  if (isArray(fieldConfig.params.type)
    && fieldConfig.params.type.length === 1) {
    return fieldConfig.params.type[0];
  }

  // TODO: ver una manera más limpia de obtener el tipo del componente que contiene el fieldValue
  switch (fieldConfig.component) {
    case 'ContentSelectorField':
      return resolveEntityType('content', fieldValue);
    case 'TaxonomySelectorField':
      return resolveEntityType('taxon', fieldValue);
    case 'EntitySelectorField':
      return fieldConfig.params.entity;
    default:
      console.warn('Unhandled type or fieldConfig for trigger population', fieldConfig);
      if (isArray(fieldConfig.params.type)) {
        return fieldConfig.params.type[0];
      }
      return null;
  }
}

export async function fetchEntityListImage(id, type) {
  let entityType = type;
  if ($store.getters.availableContentTypes.includes(type)) {
    entityType = 'content';
  } else if ($t(`message.taxonomy.type.${type}`, null) !== null) {
    entityType = 'taxon';
  }

  // Cache lookup first
  const key = `${id}-${entityType}`;
  const cachedImage = cache.get(key);
  if (cachedImage) {
    return cachedImage;
  }

  const response = await api.fetch(entityType, id, {}, {
    // 404 is a valid response too
    validateStatus: (status) => {
      if (status === 404) return true;
      return status >= 200 && status < 300;
    },
  });

  if (!response) {
    cache.set(key, null);
    return null;
  }

  const { list = null, thumbnailUrl = null, title = null } = response;
  if (list && list.image && list.image.src) {
    cache.set(key, list.image);
    return list.image;
  }
  if (!thumbnailUrl) {
    cache.set(key, null);
    return null;
  }
  const image = {
    alt: title,
    src: thumbnailUrl,
  };
  cache.set(key, image);
  return image;
}
